<template>
	<!-- Main Sections -->
	<main class="main-wrapper bg-lightest-gray">

		<section class="error-section py-40">
			<div class="container-fluid">
				<div class="error-wrapper text-center py-40 bg-white br-10">
					<h1 class="mb-32">404</h1>
					<h5 class="mb-16"><span class="color-primary">Упс!</span> Что-то пошло не так...</h5>
					<p class="light-gray mb-32">Запрашиваемая Вами страница не найдена.<br/>Возможно она была удалена либо никогда не существовала.</p>
					<router-link :to="{path: '/'}" class="cus-btn">На главную</router-link>
				</div>
			</div>
		</section>

		<benefits :footer-class="['bg-white']" />
	</main>
	<!-- Main Sections -->
	<div class="d-flex align-items-center min-vh-100 overflow-hidden">
		<div class="container">
			<div class="row">
				<div class="col-md-6 offset-md-3">
					<div class="animate__animated animate__bounceIn">
						<div class="card shadow">
							<div class="card-body text-center">
								<div style="font-size: 200px; font-weight: bold;" class="lh-1">404</div>
								<div style="font-size: 30px;">Ошибка 404</div>
								<router-link :to="{path: '/'}" class="btn btn-lg btn-primary mt-5">На главную</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import Benefits from '@/components/Benefits';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Ошибка 404'});
	},
	data: () => ({
		
	}),
	computed: {},
	methods: {},
	mounted(){
		window.scrollTo(0, 0);
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		next();
	},
	components: {
		Benefits,
	},
}
</script>